export default __webpack_public_path__ + "static/media/tick-black.4df5e913.svg";